import { formatSecondsAsTimer } from "@vericus/cadmus-common";
import { EyeIcon, PlayIcon } from "@vericus/cadmus-icons";
import { LinkButton, Text } from "@vericus/cadmus-ui";

import { show } from "@ebay/nice-modal-react";

import { VideoPreviewModal } from "@/components/video-preview-modal";

import * as styles from "./submitted-video.css";

interface Props {
  mediaUrl: string;
  durationSeconds: number | null;
  headingLabel?: string;
  isSelected?: boolean;
}

export function SubmittedVideo(props: Props) {
  const onWatchVideo = () => {
    show(VideoPreviewModal, { videoUrl: props.mediaUrl });
  };

  return (
    <div className={styles.root({ selected: props.isSelected ?? false })}>
      <div className={styles.thumbnail}>
        <video
          className={styles.thumbnailVideo}
          src={`${props.mediaUrl}#t=0.1`}
          preload="metadata"
          muted
          playsInline
          aria-hidden="true"
        />
        <button
          className={styles.play}
          onClick={onWatchVideo}
          aria-label="Watch submitted video response"
        >
          <PlayIcon size={36} label="Submitted video response" />
        </button>
      </div>
      <div className={styles.description}>
        <Text kind="headingSix">
          {props.headingLabel ?? "Your submitted video"}
        </Text>
        {typeof props.durationSeconds === "number" && (
          <Text kind="label">
            DURATION {formatSecondsAsTimer(props.durationSeconds)}
          </Text>
        )}
        <div className={styles.actions}>
          <LinkButton
            kind="primary"
            underlined={false}
            className={styles.dashedLink}
            icon={<EyeIcon label="" size={18} />}
            onClick={onWatchVideo}
          >
            Watch video
          </LinkButton>
        </div>
      </div>
    </div>
  );
}
